import { AxiosInstance } from 'axios';

import { formatCnpj } from '@mais-retorno-front/libs/util-helpers';
import { ICatchIssueUseCase } from '../catch-issue.usecase';
import { TypeAssetSlugs } from '@mais-retorno-front/constants/asset-slugs';

interface IResponse {
  ticker: string;
  company: string;
  slug: string;
  price: number;
  mkt_cap: number;
}

interface IAssetsResponse {
  pagination: {
    page: number;
    pages_quantity: number;
    total: number;
  };

  items: {
    cnpj: number;
    code_cvm: number;
    company_name: string;
    actuation_segment: string;
    actuation_sector: string;
    actuation_subsector: string;
    issuer_company: string;
    ticker: string;
    asset: string;
    asset_description: string;
    canonical_url: string;
    type: string;
    trading_currency: string;
    has_quotes: boolean;
    isin: string;
  }[];
}

export class GetStocksListUseCase {
  constructor(
    private readonly httpRequest: AxiosInstance,
    private readonly catchError: ICatchIssueUseCase
  ) {}

  async handle(
    type_slug?: TypeAssetSlugs,
    page: number = 1,
    limit: number = 50
  ) {
    try {
      const { stocks, rawList, pagination } = await this.fetchStocks(
        type_slug,
        page,
        limit
      );
      const formattedStocks = this.stockFormatter(stocks);

      return {
        pagination,
        rawList,
        list: formattedStocks,
      };
    } catch (error) {
      this.catchError.handle({
        errorName: 'GetStocksListUseCase - Get Stocks list',
        error,
        extras: { error },
      });

      throw error;
    }
  }

  private async fetchStocks(
    type_slug: TypeAssetSlugs,
    page: number,
    limit: number
  ) {
    try {
      const { data: assets } = await this.httpRequest.get<IAssetsResponse>(
        `/assets`,
        {
          params: {
            type_slug,
            page,
            limit,
          },
        }
      );

      const { pagination, items } = assets;

      return {
        pagination,
        stocks: items,
        rawList: items,
      };
    } catch (error) {}
  }

  private stockFormatter(stocks: IAssetsResponse['items']) {
    const formattedStocks = stocks.map((stock) => ({
      mainInfo: {
        name: stock.ticker,
        additionalText: stock.company_name,
        link: stock.canonical_url,
      },
      data: [
        { slug: 'cnpj', name: 'CNPJ', value: formatCnpj(stock.cnpj) },
        {
          slug: 'actuation_segment',
          name: 'Segmento',
          value: stock.actuation_segment,
        },
        {
          slug: 'actuation_sector',
          name: 'Setor',
          value: stock.actuation_sector,
        },
      ],
    }));

    return formattedStocks;
  }
}
